import { Fragment, useState } from "react";
import { Alert, Box, Button, Container, Dialog, DialogContent, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useParams } from "react-router-dom";
import { createBlockAnswers, updateBlockAnswers } from "../axios/axiosFunctions";

const Questions360Section = ({blockId,questions,color,buttonsDir,changeTab,setCurrentBlock,currentAnswers,setCurrentAnswers,userEvalInfo}) => {

    const {userEvalId,userId,groupId,assessmentSlug} = useParams();
    const [msg, setMsg] = useState("");
    const [showMsg, setShowMsg] = useState(false);
    const [msgSeverity, setMsgSeverity] = useState("error");
    const [openDialog, setOpenDialog] = useState(false);

    const handleDialogClose = ()=>{
        setOpenDialog(false);
    }

    const handleAnswers = (e)=>{
        const {name, value} = e.target;
        const findAnswer = currentAnswers.find((a)=>a.question._id === name);
        const findAnswerIndex = currentAnswers.findIndex((a)=>a.question._id === name);
        if(findAnswer){
            const newCurrentUser = [...currentAnswers];
            newCurrentUser[findAnswerIndex] = {
                ...currentAnswers[findAnswerIndex],
                answer:value
            }
            setCurrentAnswers(newCurrentUser);
        }else{
            const newCurrentUser = [...currentAnswers];
            newCurrentUser.push({
                question:{
                    _id:name
                },
                id:name,
                answer:value
            });
            setCurrentAnswers(newCurrentUser);
        }
    }

    const getRadioValue = (q)=>{
        const a = currentAnswers.find((a)=>a.question._id === q._id);
        return a?.answer || "";
    }

    const validateForm= ()=>{
        const isValid = true;
        for(let i=0;i<questions.length;i++){
            if(!currentAnswers[i]){
                return !isValid;
            }
        }
        return isValid;
    }

    const handleSubmit = async(e)=>{
        
        e.preventDefault();
        const isValid = validateForm();

        if(!isValid){
            setMsg("Please complete all questions");
            setMsgSeverity("error");
            setShowMsg(true);
            setTimeout(() => {
              setShowMsg(false);
            }, 2000);
            return;
        }

        const data = {
            userId : userId,
            to: userEvalId,
            blockId,
            groupId: groupId,
            answers:currentAnswers,
        }

        let res;

        if(currentAnswers[0]?._id){
            res = await updateBlockAnswers(data);
        }else{
            res = await createBlockAnswers(data);
        }

        if(!res){
            setMsg("Error while saving, please try later");
            setMsgSeverity("error");
            setShowMsg(true);
            setTimeout(() => {
                setShowMsg(false);
            }, 2000);
        }
        setCurrentBlock(buttonsDir.after);
        window.scrollTo(0, 0);
    }

    const handleSubmitComplete = async()=>{
        setOpenDialog(false);
        const isValid = validateForm();

        if(!isValid){
            setMsg("Please complete all questions");
            setMsgSeverity("error");
            setShowMsg(true);
            setTimeout(() => {
              setShowMsg(false);
            }, 2000);
            return;
        }

        const data = {
            userId : userId,
            to: userEvalId,
            blockId,
            groupId: groupId,
            answers:currentAnswers,
        }

        let res;

        if(currentAnswers[0]?._id){
            res = await updateBlockAnswers(data);
        }else{
            res = await createBlockAnswers(data);
        }

        if(!res){
            setMsg("Error while saving, please try later");
            setMsgSeverity("error");
            setShowMsg(true);
            setTimeout(() => {
                setShowMsg(false);
            }, 2000);
        }
        setCurrentBlock(undefined);
        changeTab(2);
    }

    const handleBackToMenu = ()=>{
        setCurrentBlock(undefined);
        changeTab(0);
    }

    return (
    <Container>
        <Box display={"flex"} sx={{marginTop:"40px",paddingBottom:"48px"}}>
            <form onSubmit={handleSubmit}>
            {
                questions?.map((q,i)=>(
                    <Fragment key={i}>
                        <Typography variant="body1" fontWeight={600} color={color} sx={{fontSize:"1.05rem",marginTop:i > 0 ? "28px" : "0px"}}>{i+1}. {userId !== userEvalId ? `How confident are you that ${userEvalInfo?.firstName || ""} ${userEvalInfo?.lastName || ""} ` : ""}{q.text}</Typography>
                        <RadioGroup row value={getRadioValue(q)} onChange={(e)=>handleAnswers(e,i)} sx={{justifyContent:"space-between",padding:"4px 10px 0px"}}>
                            {userId !== userEvalId && <FormControlLabel value="unable" name={q._id} control={<Radio/>} label="Unable to Respond"/>}
                            <FormControlLabel value="notConfident" name={q._id} control={<Radio/>} label="Not Confident"/>
                            <FormControlLabel value="somewhat" name={q._id} control={<Radio/>} label="Somewhat Confident"/>
                            <FormControlLabel value="confident" name={q._id} control={<Radio/>} label="Confident"/>
                            <FormControlLabel value="very" name={q._id} control={<Radio/>} label="Very Confident"/>
                        </RadioGroup>
                    </Fragment>
                ))
            }
            {
                showMsg &&
                <Alert sx={{marginTop:"20px"}} severity={msgSeverity}>
                    {msg}
                </Alert>
            }
            <Box display={"flex"} justifyContent={"space-around"} sx={{marginTop:"30px"}}>
                {
                    buttonsDir.before ?
                    <Button onClick={()=>{ setCurrentBlock(buttonsDir.before); window.scrollTo(0, 0); }} variant="contained" color="secondary" startIcon={<ArrowBackIcon className="invertIconBlue"/>} sx={{color:"white"}}>BACK</Button>
                    :
                    <Button onClick={handleBackToMenu} variant="contained" color="secondary" startIcon={<ArrowBackIcon className="invertIconBlue"/>} sx={{color:"white"}}>BACK</Button>
                }
                {
                    buttonsDir.after ?
                    <Button type='submit' variant="contained" sx={{color:"white"}} endIcon={<ArrowForwardIcon className="invertIcon"/>}>NEXT</Button>
                    : 
                    <Button onClick={()=>setOpenDialog(true)} variant="contained" sx={{color:"white"}}>COMPLETE</Button>
                }
                <Dialog open={openDialog} onClose={handleDialogClose}>
                    <DialogContent>
                        <Typography variant='h6' sx={{textAlign:"center"}}>Are you sure you want to SUBMIT your assessment?</Typography>
                        <Typography variant='subtitle1' sx={{textAlign:"center"}}>Once you submit, you WON'T be able to change your responses.</Typography>
                        <Box sx={{display:"flex",margin:"20px",justifyContent:"center"}}>
                            <Button onClick={handleSubmitComplete} variant='contained'sx={{marginRight:"20px",justifyContent:"space-around"}}>COMPLETE</Button>
                            <Button variant='contained' onClick={handleDialogClose} color="customGray">CANCEL</Button>
                        </Box>
                    </DialogContent>
                </Dialog>
            </Box>
            </form>
        </Box>
    </Container>
    )
}

export default Questions360Section